import * as React from 'react';
import { HeaderLogo, HeaderText, HeaderTextWrap, HeaderWrapper } from './styles';
import coeLogo from '../../assets/coe-logo.jpg';

export const PageHeader = (): JSX.Element => (
  <HeaderWrapper style={{ backgroundColor: '#FF9C00' }}>
    <HeaderLogo src={coeLogo} />
    <HeaderTextWrap>
      <HeaderText> College of Engineering, KNUST</HeaderText>
      <HeaderText> Exams Office</HeaderText>{' '}
    </HeaderTextWrap>
  </HeaderWrapper>
);
